import PropTypes from 'prop-types';
import { AddressPropType } from './address';
import { CurrencyPropType } from './currency';

export const EditOrderRequestPropType = PropTypes.shape({
  shipByDateTime: PropTypes.string,
  paidDateTime: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  holdUntilDateTime: PropTypes.string,
  orderDateTime: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      salesOrderItemId: PropTypes.string,
      sku: PropTypes.string,
      name: PropTypes.string,
      quantity: PropTypes.number,
      unitPrice: CurrencyPropType,
    }),
  ),
  amountSummary: PropTypes.shape({
    shippingPaid: CurrencyPropType,
    taxPaid: CurrencyPropType,
    totalPaid: CurrencyPropType,
  }),
  customer: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
    phone: PropTypes.string,
  }),
  isGift: PropTypes.bool,
  shipToAddress: AddressPropType,
  orderNumber: PropTypes.string,
  createGuid: PropTypes.string,
  store: PropTypes.shape({
    storeGuid: PropTypes.string,
  }),
});

/**
 * @typedef {object} EditOrderRequestItemPropType
 * @property {string} salesOrderItemId
 * @property {string} sku
 * @property {string} name
 * @property {string} quantity
 * @property {CurrencyPropType} unitPrice
 */

/**
 * @typedef {object} EditOrderRequestPropType
 * @property {string} shipByDateTime
 * @property {string|Date} paidDateTime
 * @property {string} holdUntilDateTime
 * @property {string|Date} orderDateTime
 * @property {EditOrderRequestItemPropType[]} items
 * @property {object} amountSummary
 * @property {CurrencyPropType} amountSummary.shippingPaid
 * @property {CurrencyPropType} amountSummary.taxPaid
 * @property {CurrencyPropType} amountSummary.totalPaid
 * @property {object} customer
 * @property {string} customer.email
 * @property {string} customer.name
 * @property {string} customer.phone
 * @property {boolean} isGift
 * @property {AddressPropType} shipToAddress
 * @property {string} orderNumber
 * @property {string} createGuid
 * @property {object} store
 * @property {string} store.storeGuid
 */
